import request from '@/plugins/axios'

/** S 商城列表 **/
// 商城列表
export const apiShopLists = (params: any) => request.get('/shop.shop/lists', {params})

// 添加商城
export const apiShopAdd = (params: any) => request.post('/shop.shop/add', params)

// 商城详情
export const apiShopDetail = (params: any) => request.get('/shop.shop/detail', {params})
// 租户等级，套餐下拉
export const apiShopSelect = (params: any) => request.get('/shop.shop/getDefaultInfo', { params })

// 编辑商城
/**
 * 编辑店铺信息的API接口函数
 * @param params - 包含店铺信息的参数对象
 * @returns 返回一个Promise对象，包含服务器响应的数据
 */
export const apiShopEdit = (params: any) => request.post('/shop.shop/edit', params)
/**
 * 复制其他店铺主题覆盖原本主题的API接口函数
 * @param params - 包含复制主题所需参数的对象
 * @returns 返回一个Promise，通过request.post发送请求到'/shop.shop/copyTheme'端点
 */
export const apiChangeTheme = (params: any) => request.post('/shop.shop/copyTheme', params)

// 删除商城
export const apiShopDelete = (params: any) => request.post('/shop.shop/delete', params)

// 修改超级管理员
export const apiShopChangeSuperAdmin = (params: any) => request.post('/shop.shop/changeSuperAdmin', params)
/**
 * 获取可选业务员列表
 * @param params - 请求参数对象，包含查询商家业务所需的各种条件
 * @returns 返回一个Promise，通过request.get发送请求，获取业务员列表
 */
export const apiShopBusinessList = (params: any) => request.get('/shop.shop/getShopBusinessList', { params })
/**
 * 更新业务员
 * @param params - 包含更新商业ID所需的参数对象
 * @returns 返回一个Promise，通过request.post发送请求到'/shop.shop/updateBusinessId'接口
 */
export const apiShopUpdateBusinessId = (data: any) => request.post('/shop.shop/updateBusinessId', data)
// 修改商城状态
export const apiShopSwitchStatus = (params: any) => request.post('/shop.shop/switchStatus', params)

// 历史套餐
export const apisetMealLogLists = (params: any) => request.get('/shop.shop/setMealLogLists', {params})

// 修改商城备注
export const apiChangeRemark = (params: any) => request.post('/shop.shop/changeRemark', params)
export const apiChangeGrade = (params: any) => request.post('/shop.shop/changeGrade', params)
/** E 商城列表 **/

/** S 套餐列表 **/
// 套餐列表
export const apiSetMealLists = (params: any) => request.get('/shop.set_meal/lists', {params})

// 添加套餐
export const apiSetMealAdd = (params: any) => request.post('/shop.set_meal/add', params)

// 套餐详情
export const apiSetMealDetail = (params: any) => request.get('/shop.set_meal/detail', {params})

// 编辑套餐
export const apiSetMealEdit = (params: any) => request.post('/shop.set_meal/edit', params)

// 删除套餐
export const apiSetMealDelete = (params: any) => request.post('/shop.set_meal/del', params)

// 修改套餐状态
export const apiSetMealSwitchStatus = (params: any) => request.post('/shop.set_meal/status', params)

export const apiMealModule = () => request.get('/shop.set_meal/getMealModule')
/** E 套餐列表 **/

// 无感登录url
export const unLoginUrl = (params:any) => request.get('/shop.shop/getShopLoginUrl',{params})

